"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@/components/auth/Auth";
import styles from "@/components/nft-image/NFTImage.module.scss";
import { useNftBalanceFromContext } from "@/components/nft-image/NftBalancesContext";
import { useNftBalance } from "@/hooks/useNftBalance";
interface Props {
  readonly contract: string;
  readonly tokenId: number;
  readonly height: 300 | 650 | "full";
  readonly inline?: boolean | undefined;
}
export default function NFTImageBalance(t0) {
  const $ = _c(22);
  const {
    contract,
    tokenId,
    height,
    inline: t1
  } = t0;
  const inline = t1 === undefined ? false : t1;
  const {
    connectedProfile
  } = useAuth();
  const consolidationKey = connectedProfile?.consolidation_key ?? null;
  let t2;
  if ($[0] !== consolidationKey || $[1] !== contract || $[2] !== tokenId) {
    t2 = {
      consolidationKey,
      contract,
      tokenId
    };
    $[0] = consolidationKey;
    $[1] = contract;
    $[2] = tokenId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const contextBalance = useNftBalanceFromContext(t2);
  const t3 = !contextBalance;
  let t4;
  if ($[4] !== consolidationKey || $[5] !== contract || $[6] !== t3 || $[7] !== tokenId) {
    t4 = {
      consolidationKey,
      contract,
      tokenId,
      enabled: t3
    };
    $[4] = consolidationKey;
    $[5] = contract;
    $[6] = t3;
    $[7] = tokenId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const {
    balance: nftBalance,
    isLoading,
    error
  } = useNftBalance(t4);
  let t5;
  if ($[9] !== contextBalance || $[10] !== error || $[11] !== isLoading || $[12] !== nftBalance) {
    t5 = contextBalance ?? {
      balance: nftBalance,
      isLoading,
      error
    };
    $[9] = contextBalance;
    $[10] = error;
    $[11] = isLoading;
    $[12] = nftBalance;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const balanceState = t5;
  let t6;
  let t7;
  if ($[14] !== balanceState.balance || $[15] !== balanceState.error || $[16] !== balanceState.isLoading || $[17] !== connectedProfile || $[18] !== height || $[19] !== inline) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const printBalance = () => {
        if (balanceState.balance > 0) {
          return printBalanceSpan(`SEIZED x${balanceState.balance}`);
        } else {
          return printBalanceSpan("UNSEIZED");
        }
      };
      const printBalanceSpan = b => {
        if (inline) {
          return <span className={styles.balanceInline}>{b}</span>;
        }
        return <span className={`${styles.balance} ${height === 650 ? styles.balanceBigger : ""} `}>{b}</span>;
      };
      if (!connectedProfile) {
        t7 = null;
        break bb0;
      }
      if (balanceState.isLoading) {
        t7 = printBalanceSpan("...");
        break bb0;
      }
      if (balanceState.error) {
        console.error("Failed to fetch NFT balance:", balanceState.error);
        t7 = printBalanceSpan("N/A");
        break bb0;
      }
      t6 = printBalance();
    }
    $[14] = balanceState.balance;
    $[15] = balanceState.error;
    $[16] = balanceState.isLoading;
    $[17] = connectedProfile;
    $[18] = height;
    $[19] = inline;
    $[20] = t6;
    $[21] = t7;
  } else {
    t6 = $[20];
    t7 = $[21];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  return t6;
}